module.exports = __webpack_public_path__ + "img/japan-liver-cancer-male.5deae79e.png";